import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { CONSTANTS } from "../../../../../Constants/Constants";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { TranslatePipe } from "@ngx-translate/core";
import { CommonDataService } from "../../../../../services/common-data.service";

@Component({
    selector: 'app-sol-properties-electrical-services',
    templateUrl: './sol-properties-electrical-services.component.html',
    styleUrls: ['./sol-properties-electrical-services.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMaskDirective,
        TranslatePipe
    ],
    providers: [provideNgxMask()]
})
export class SolPropertiesElectricalServicesComponent implements OnInit {
    electricalServicesForm:FormGroup<{
        riskPercentage: FormControl<number>;
        costPerLabel: FormControl<number>;
        fieldDataCollectionRate: FormControl<number>;
        dataCollectionMultiplier: FormControl<number>;
        baseStudyDifficultyMultiplier: FormControl<number>;
        motorStartingStudyMultiplier: FormControl<number>;
        shortCircuitRiskPercentage: FormControl<number>;
    }>
    private destroyRef = inject(DestroyRef);

    constructor(private readonly fb: NonNullableFormBuilder,
        private readonly commonDataService: CommonDataService
    ) { }

    ngOnInit(): void {
        this.initializeForm();
        this.setupReadOnlyMode();
    }

    private setupReadOnlyMode(): void {
        this.commonDataService.readOnlyMode$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(isReadOnly => {
                if (isReadOnly) {
                    this.electricalServicesForm.disable({ emitEvent: false });
                } else {
                    this.electricalServicesForm.enable({ emitEvent: false });
                }
            });
    }

    private initializeForm(): void {
        this.electricalServicesForm = this.fb.group({
            riskPercentage: this.fb.control<number>(CONSTANTS.ZERO),
            costPerLabel: this.fb.control<number>(CONSTANTS.ZERO),
            fieldDataCollectionRate: this.fb.control<number>(CONSTANTS.ZERO),
            dataCollectionMultiplier: this.fb.control<number>(CONSTANTS.ZERO),
            baseStudyDifficultyMultiplier: this.fb.control<number>(CONSTANTS.ZERO),
            motorStartingStudyMultiplier: this.fb.control<number>(CONSTANTS.ZERO),
            shortCircuitRiskPercentage: this.fb.control<number>(CONSTANTS.ZERO),
        });
    }
}